module.exports = __webpack_public_path__ + "img/상암동 샐러드.ee4e68e0.png";